import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Button } from "../ui/button";
import { Sparkles, Lock } from "lucide-react";
import { Markdownish } from "./markdown";

export default function AiNarrativeCard({ text, audience, proActive, onUnlock }) {
  const isAnalyst = audience === "analyst";

  if (!text) {
    return (
      <Card className="bg-white border-[#E5E0D8] shadow-none">
        <CardContent className="py-10 text-center text-[#5C665D]">
          AI narrative was disabled or unavailable for this run.
        </CardContent>
      </Card>
    );
  }

  if (!proActive) {
    return (
      <Card
        className="bg-white border-[#E5E0D8] shadow-none relative overflow-hidden"
        data-testid="ai-narrative-locked"
      >
        <CardHeader>
          <div className="flex items-center gap-2">
            <Sparkles size={18} strokeWidth={1.5} className="text-[#C26D5C]" />
            <CardTitle className="font-serif-display text-xl text-[#1F382E]">
              {isAnalyst ? "Credit memo (educational)" : "CFO advisor memo"}
            </CardTitle>
          </div>
          <CardDescription className="text-[#5C665D]">
            {isAnalyst
              ? "Lender / underwriter framing. Generated by Claude Sonnet 4.5."
              : "Owner-operator framing. Generated by Claude Sonnet 4.5."}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="relative">
            <div
              className="text-[#1A1A1A] leading-relaxed select-none"
              style={{
                maskImage:
                  "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 30%, rgba(0,0,0,0.1) 90%, rgba(0,0,0,0) 100%)",
                WebkitMaskImage:
                  "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 30%, rgba(0,0,0,0.1) 90%, rgba(0,0,0,0) 100%)",
                filter: "blur(0.4px)",
              }}
              aria-hidden="true"
            >
              <Markdownish text={text.split("\n").slice(0, 12).join("\n")} />
            </div>
            <div className="absolute inset-x-0 bottom-0 flex flex-col items-center justify-end gap-3 pb-2 pt-16">
              <div className="w-full max-w-md text-center bg-white border border-[#1F382E]/15 rounded-xl p-6 shadow-sm">
                <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-[#C26D5C]">
                  <Lock size={11} strokeWidth={1.5} />
                  Pro feature
                </div>
                <p className="font-serif-display text-2xl text-[#1F382E] mt-2 tracking-tight">
                  Unlock the full memo.
                </p>
                <p className="text-sm text-[#5C665D] mt-2 leading-relaxed">
                  Pro Pass ($29, 30 days) unlocks the AI advisor memo and unlimited PDF
                  exports — on this device, no account needed.
                </p>
                <Button
                  onClick={onUnlock}
                  className="mt-4 bg-[#1F382E] hover:bg-[#142922] text-[#F7F5F0] rounded-md h-11 px-6 transition-all duration-300"
                  data-testid="ai-memo-unlock-btn"
                >
                  <Sparkles size={14} strokeWidth={1.5} className="mr-2" />
                  Unlock with Pro
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-white border-[#E5E0D8] shadow-none" data-testid="ai-narrative-card">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Sparkles size={18} strokeWidth={1.5} className="text-[#C26D5C]" />
          <CardTitle className="font-serif-display text-xl text-[#1F382E]">
            {isAnalyst ? "Credit memo (educational)" : "CFO advisor memo"}
          </CardTitle>
        </div>
        <CardDescription className="text-[#5C665D]">
          {isAnalyst
            ? "Lender / underwriter framing. Generated by Claude Sonnet 4.5. Educational insight — not a real underwriting decision."
            : "Owner-operator framing. Generated by Claude Sonnet 4.5. Educational insight — not financial advice."}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Markdownish text={text} />
      </CardContent>
    </Card>
  );
}
